import { useCallback, useState } from 'react'

export function useLocalStorage<T>(key: string, initialValue: T) {
  const [value, setValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key)
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      console.error(error)
      return initialValue
    }
  })

  const setLocalStorage = useCallback(
    (value: T, saveOnStorageOnly?: boolean) => {
      try {
        if (!saveOnStorageOnly) {
          setValue(value)
        }
        window.localStorage.setItem(key, JSON.stringify(value))
      } catch (error) {
        console.error(error)
      }
    },
    [key]
  )

  return [value, setLocalStorage] as const
}
